/* eslint-disable comma-dangle */

export default {
  address: ['coworking-name'],
  'about-object': [
    'coworking-workplace-count',
    'coworking-total-area',
    'coworking-floor',
    'coworking-access-type',
    'coworking-price',
    'price-and-deal-terms/included-options',
    'coworking-min-lease-term',
  ],
};
